import React, { ReactElement, useContext, useMemo } from 'react';
import WildcardTextInput, {
  WildcardInputPreviewModes,
  WildcardInputQuestionTypes,
} from 'pages/Forms/FormsContent/FormsDrafting/WildcardInputs/WildcardTextInput';
import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import { FormTemplateType } from 'shared/types/graphql';

interface Props {
  prompt: string;
  inline?: boolean;
  isRequired: boolean;
  isTextBlock?: boolean;
}

function Prompt({ prompt, inline, isRequired, isTextBlock = false }: Props): ReactElement {
  const { formTemplateType, hasLinkedAutomations, clinicWidgetRequestTypes } = useContext(FormsContext);
  const isWidgetRequestForm = !!clinicWidgetRequestTypes?.length;
  const isServiceReminderForm = formTemplateType === FormTemplateType.ServiceReminder;

  const allowFillInTheBlankWildcards = useMemo(() => {
    return !isServiceReminderForm && !isWidgetRequestForm && !hasLinkedAutomations;
  }, [isServiceReminderForm, hasLinkedAutomations, isWidgetRequestForm]);

  return (
    <Flex as="p" display={inline ? 'inline-flex' : 'flex'} fontSize="lg" fontWeight={isTextBlock ? 400 : 600}>
      <WildcardTextInput
        text={prompt}
        type={WildcardInputQuestionTypes.Question}
        previewMode={WildcardInputPreviewModes.Form}
        allowFillInTheBlanks={allowFillInTheBlankWildcards}
      />
      {isRequired ? (
        <Box as="span" height="7px" width="7px" color="text.danger">
          *
        </Box>
      ) : null}
    </Flex>
  );
}

export default Prompt;
